var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 104.275,
    viewBox: "0 0 150 104.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fish",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M14.2,76.707a47.282,47.282,0,0,1,0-56.048C31.812,30.142,41.538,46.2,42.107,47.152a3.093,3.093,0,0,1,0,3.06C41.538,51.16,31.812,67.223,14.2,76.707Zm5.619-37.4H15.693a3,3,0,1,0,0,6h4.125a3,3,0,1,0,0-6Z",
    transform: "translate(107.488 3.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M25.763,12.62c19.709,0,31.019,8.49,34.228,11.31-1.08-.03-2.13-.06-3.18-.06a77.348,77.348,0,0,0-27,5.31,25.486,25.486,0,0,1-7.53-12.989,2.931,2.931,0,0,1,.63-2.46,2.962,2.962,0,0,1,2.28-1.08A3.824,3.824,0,0,1,25.763,12.62Z",
    transform: "translate(38.336 -12.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M22.912,57.309a2.932,2.932,0,0,1-.63-2.46,25.485,25.485,0,0,1,7.53-12.989,77.353,77.353,0,0,0,27,5.31c1.05,0,2.1-.03,3.18-.06-3.21,2.82-14.519,11.31-34.228,11.31a3.821,3.821,0,0,1-.57-.03A2.962,2.962,0,0,1,22.912,57.309Z",
    transform: "translate(38.336 45.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M16.405,20.435a3,3,0,0,1,2.7-2.67c.75-.06,18.509-1.77,28.8,8.49a25.557,25.557,0,0,1,3.69,4.77,10.607,10.607,0,0,0,14.7,3.66c16.439-9.84,31.619-14.819,45.118-14.819a54.571,54.571,0,0,1,21.059,4.26,53.119,53.119,0,0,0,0,61.257,54.567,54.567,0,0,1-21.059,4.26c-13.5,0-28.679-4.98-45.118-14.819a10.607,10.607,0,0,0-14.7,3.66,25.565,25.565,0,0,1-3.69,4.77c-7.62,7.59-19.289,8.64-25.169,8.64a33.96,33.96,0,0,1-3.63-.15,3,3,0,0,1-2.7-2.67c-.06-.75-1.77-18.539,8.52-28.8a25.8,25.8,0,0,1,8.31-5.52,25.8,25.8,0,0,1-8.31-5.52C14.635,38.974,16.345,21.185,16.405,20.435Z",
    transform: "translate(-16.264 -2.615)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/Fish.7e96f9544957cd7af3cd6d7446afd83e.svg";
export { ForwardRef as ReactComponent };